export default {
  home: {
    minute: 'Phút',
    price_info: 'Miễn phí{mianfei}phút đầu, hạn mức cao nhất {currencyName}{fengding}, khi số tiền trong ví hết{currencyName}{yajin}tự động trừ vào tiền cọc',
    feature_1: 'Tích hợp 3 loại cáp sạc, phù hợp với tất cả các dòng điện thoại',
    feature_2: 'Thuê và trả tại mọi nơi',
    feature_3: 'Thiết kế đặc biệt dành cho sạc dự phòng',
    tips_1: 'Số dư không đủ，phải nạp thêm{currencyName}{yajin}mới có thể dùng tiền cọc',
    tips_2: 'Thanh toán tiền cọc{currencyName}{yajin}là có thể thuê, hoàn trả sau khi dùng xong',
    tips_3: 'Số dư tiền cọc hiện tại là{currencyName}{yajin}，có thể thuê ngay',
    submit: 'Nạp tiền ngay',
    borrow: 'Thuê ngay',
    msg_fail_title: 'Cảnh báo',
    msg_fail_content: 'Thuê không thành công, vui lòng thử lại',
    goborrow: 'Thuê!!!',
    msg_fail_order: 'Có một đơn đặt hàng chưa thanh toán',
    goorder: 'Thanh toán'
  },
  login: {
    code_title: 'Mã OTP',
    phone_number: 'Số điện thoại',
    verification_code: 'Nhập mã captcha',
    captcha_code: 'Mã captcha',
    send_code: 'Nhận mã xác thật',
    login: 'Đăng nhập',
    agree: 'Nhấp để đăng nhập, bạn đã đọc và đồng ý',
    readme: 'Điều khoản sử dụng',
    msg_fail_login: 'Đăng nhập không thành công',
    msg_success_login: 'Đăng nhập thành công',
    msg_fail_user: 'Lỗi khi lấy thông tin người dùng, bạn có muốn thử lại không',
    sign_in_with: 'Bên thứ ba đăng nhập',
    no_sms: 'Không nhận được sms',
    retry: 'Gửi lại',
    authorized_login: 'Ủy quyền đăng nhập',
    authorized_tips1: 'Yêu cầu có quyền sau',
    authorized_tips2: 'Lấy thông tin công khai của bạn(nickname、avatar、khu vực và giới tính)'
  },
  confirm: {
    title: 'Xác nhận thanh toán',
    pay_label: 'Cần thanh toán',
    auth_label: 'Ủy quyền trước',
    price_tips: 'Tiền sẽ được chuyển vào tài khoản từ 1-5 ngày sau khi gửi lệnh xin hoàn tiền',
    auth_tips: 'Tiền cọc ủy quyền trước{currencyName}{yajin},sẽ được hoàn lại sau khi khấu trừ chi phí thuê thực tế',
    pay_type: 'Hãy lựa chọn phương thức thanh toán',
    submit: 'Xác nhận thanh toán',
    msg_loading: 'Đang tải',
    msg_fail_title: 'Cảnh báo',
    msg_fail_payment: 'Gửi lệnh thanh toán tiền cọc không thành công',
    msg_fail_order: 'Tạo đơn hàng không thành công',
    msg_fail_support: 'Không hỗ trợ đường truyền hiện tại',
    msg_fail_confirm: 'Xác nhận',
    msg_fail_retry: 'Thử lại lần nữa',
    msg_fail_cancel: 'Hủy'
  },
  mine: {
    title: 'Trang của tôi',
    wallet: 'Ví của tôi',
    balance: 'Số dư trong ví',
    deposit: 'Tiền cọc',
    wallet_in: 'Nạp tiền',
    wallet_out: 'Rút tiền',
    wallet_log: 'Gửi và rút tiền',
    order: 'Đơn hàng thuê',
    coupon: 'Phiếu ưu đãi',
    login_tips: 'Hãy đăng nhập',
    msg_fail_title: 'Cảnh báo',
    msg_fail_update: 'Sửa đổi không thành công, vui lòng thử lại',
    msg_loading: 'Đang tải',
    msg_fail_user: 'Lỗi lấy thông tin của người dùng, bạn có muốn thử lại không',
    help: 'Giúp đỡ',
    setting: 'Cài đặt ',
    logout: 'Thoát',
    buy: 'Mua thiết bị',
    frozen: 'Đóng băng',
    wallet_tips: 'Lưu ý: Vui lòng thanh toán tiền cọc trước khi thuê pin'
  },
  msg: {
    loading: 'Đang tải',
    title: 'Cảnh báo',
    success: 'Thao tác thành công',
    error: 'Lỗi không xác định, vui lòng liên hệ quản trị viên',
    confirm: 'Xác nhận',
    retry: 'Thử lại',
    cancel: 'Hủy',
    title_fail: 'Lỗi',
    success_payment: 'Nạp tiền thành công',
    success_buy: 'Mua thành công',
    fail_payment: 'Thanh toán không thành công',
    keyword: 'Từ khóa',
    success_pay: 'Thanh toán thành công'
  },
  result: {
    title: 'Xác nhận kết quả',
    price_plan: 'Nguyên tắc tính phí',
    msg_success: 'Thuê thành công',
    msg_tips_loading: 'Đang đẩy pin ra, vui lòng chờ trong giây lát',
    msg_result_loading: 'Đang xác nhận kết quả thanh toán',
    msg_fail_confirm: 'Xác nhận',
    btn_usage: 'Hướng dẫn sử dụng',
    btn_return: 'Hướng dẫn hoàn trả',
    deposit: 'Tiền cọc',
    msg_fail_content: 'Lệnh yêu cầu không thành công, vui lòng thử lại',
    price_label: '/giờ',
    price_info: 'Miễn phí{mianfei}phút，hạn mức cao nhất {fengding}{ccurrency}，khi số tiền trong ví hết {yajin}{ccurrency}tự động trừ vào tiền cọc',
    tips_1: 'Vui lòng lấy pin theo hình hướng dẫn<span class="number">{number}số</span>vị trí pin sạc dự phòng',
    tips_2: 'Khi hoàn trả đưa sạc dự phòng theo hướng mũi tên<span class="highlight">【mặt có cáp sạc nằm dưới】</span>đẩy vào khe thiết bị',
    msg_note_usage: 'Sạc dự phòng được trang bị sẵn ba loại cáp sạc, tùy theo nhu cầu sử dụng',
    msg_note_return: ' Vui lòng để cáp sạc trở lại đúng vị trí và trả sạc dự phòng vào trong khe của thiết bị',
    return_info: 'Khi hoàn trả, vui lòng để cáp sạc nằm gọn đúng vị trí, đặt đầu chip của sạc dự phòng vào khe mấy cho đến khi phần đáy được cố định'
  },
  result_msg: {
    loading: 'Đang tải',
    refresh: 'Nhấp để tải lại'
  },
  order: {
    title: 'Đơn hàng thuê mượn',
    in_use: 'Đang được sử dụng',
    ended: 'Đã kết thúc',
    msg_error: 'Tải không thành công'
  },
  order_item: {
    order_number: 'Mã đơn hàng',
    venue_rented: 'Địa điểm thuê',
    time_rented: 'Thời gian thuê',
    venue_returned: 'Địa điểm hoàn trả',
    time_returned: 'Thời gian hoàn trả',
    charge_standard: 'Tiêu chuẩn thu phí',
    charge_standard_info: 'Mỗi giờ{pJifei}{pCurrency}(dưới{pMian}phút miễn phí)',
    rent_occurred: 'Phí dịch vụ',
    returned: 'Đã hoàn trả',
    unreturned: 'Chưa hoàn trả',
    type_0: 'Chưa thuê',
    type_1: 'Đang được thuê',
    type_2: 'Đã hủy',
    type_3: 'Đã hoàn trả',
    type_4: 'Có thắc mắc',
    type_5: 'Trả lại ngoài giờ',
    min: 'Phút',
    unpaid: 'Chưa thanh toán',
    payment: 'Thanh toán'
  },
  setting: {
    title: 'Cài đặt',
    lang: 'Lựa chọn ngôn ngữ'
  },
  help: {
    title: 'Giúp đỡ'
  },
  wallet_in: {
    title: 'Nạp và rút tiền',
    price_label: 'Số tiền nạp vào',
    price_placeholder: 'Nhập số tiền cần nạp',
    balance: 'Số dư hiện tại',
    price_auto: 'Tự động nạp tiền',
    price_tips: 'Tiền sẽ được trả vào tài khoản từ 1-5 ngày sau khi gửi lệnh xin hoàn tiền',
    submit: 'Xác nhận nạp tiền',
    loading: 'Đang tải',
    paying: ' Chuyển sang giao diện thanh toán',
    msg_title: 'Cảnh báo',
    msg_fail_order: 'Tạo lệnh nạp tiền không thành công',
    msg_fail_payment: 'Gửi lệnh nạp tiền không thành công',
    msg_fail_retry: 'Thử lại'
  },
  wallet_out: {
    title: 'Rút số dư',
    price_label: 'Số tiền muốn rút',
    price_placeholder: 'Vui lòng nhập số tiền muốn rút',
    balance: 'Số dư hiện tại',
    balance_all: 'Rút toàn bộ',
    deposit: 'Tiền cọc',
    deposit_tips: 'Có một đơn hàng đang được thuê，tạm thời{pcurrencyName}{pyajin}không thể hoàn tiền cọc',
    submit: 'Rút tiền ngay',
    apply: 'Yêu cầu rút tiền tiền',
    confirm: 'Xác nhận',
    loading: 'Đang tải',
    msg_fail_price: 'Số tiền muốn rút không đúng',
    msg_fail_balance: ' Số tiền muốn rút không được cao hơn số dư hiện tại',
    msg_title: 'Lỗi',
    msg_success_content: 'Yêu cầu rút tiền thành công'
  }
}
